export default {"src":"/images/9.jpg","width":5184,"height":3456,"aspectRatio":1.5};